let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kOIpw")).then(() => parcelRequire('hPeTv'));